
import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import JumboDemoCard from "@jumbo/components/JumboDemoCard/JumboDemoCard";
import SweetAlert from "app/pages/components/mui/Alerts/SweetAlert";
import {
  Grid,
} from "@mui/material";
import { getCoursesUserApi } from 'backendServices/ApiCalls';

import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { CleaningServices } from "@mui/icons-material";





const CourseUserList = () => {
const [list,setList]=useState([])
const [searchParams] = useSearchParams();
const courseId = searchParams.get("cid");
const [isLoading,setIsLoading]=useState(false)


  
  const [alertData, setalertData] = useState({
    show: false,
    message: "",
    variant: "",
  });




  const getCourses = () => {

    setIsLoading(true);
    getCoursesUserApi(
      courseId,
      (response) => {
        const processedData = response?.data?.data?.map((row, index) => ({
          ...row,
          index: index + 1,
        }));
        setList(processedData || []);
        setIsLoading(false);
      },
      (error) => {
        setIsLoading(false);
        console.log(error);
      }
    );
      setIsLoading(false);
  };

  

  useEffect(() => {
    getCourses();
  }, []);







   var columns = [
      {
        field: "index",
        headerName: "#",
        width: 80,
      },
      {
        field: "name",
        headerName: "Name",
        width: 200,
        groupable: false,
         renderCell: (params) => (
          <span style={{ cursor: "pointer"}}
          onClick={()=>console.log(params.row)}
          >
           {params.row?.firstname +" "+ params.row?.lastname}
         </span>
  ),
      },
       {
        field: "email",
        headerName: "Email",
        width: 300,
        groupable: false,
      },
    ];
 
  // }
  const gridDesign = {
    "& .MuiDataGrid-toolbarContainer": {
      "& .MuiButton-text": {
        fontSize: "13px !important",
      },
      "& .MuiBadge-badge": {
        backgroundColor: "#074682",
        // color: '#074682',
      },
      "& .MuiBadge-badge": {
        backgroundColor: "#074682",
      },
      "& .MuiInput-root": {
        borderRadius: 2,
        paddingLeft: 2,
        overflow: "hidden",
      },
    },
  };
  //



  
  



  return (
    <Grid
      container
      fullWidth
      sm={12}
      xs={12}
      p={2}
      alignItems="center"
      justifyContent="center"
      
    >

      <Grid item sm={12} xs={12}>
        <JumboDemoCard
          title={""}
          wrapperSx={{ backgroundColor: "background.paper", pt: 0 }}
        >
          {alertData.show && (
            <SweetAlert alertData={alertData} setalertData={setalertData} />
          )}


          <Box sx={{ height: 500, width: 1 }}>
            <DataGrid
              initialState={{
                pagination: { paginationModel: { pageSize: 6 } },
              }}
              rows={list}
              getRowId={(row) => row.id}
              columns={columns}
              slots={{ toolbar: GridToolbar }}
              sx={gridDesign}
              pageSizeOptions={[6, 12, 18, 24, 30]}
              loading={isLoading}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
          </Box>
   
          {/* )} */}

         
        </JumboDemoCard>
      </Grid>


    </Grid>
  );
};

export default CourseUserList;




